import { manualReviewTasks } from 'Automations/nodeDefinitions/nodeDefinitions'
import { notificationDefinitions } from './notifications/notificationDefinitions'

/**
 * The watchtower task types the frontend knows how to render in the inbox.
 * Computed lazily (via a function rather than a module-level constant) because
 * `manualReviewTasks` is built from `nodeDefinitions`, and evaluating it at
 * import time hits a circular-import ordering where it is still undefined.
 */
export const getRecognisedTaskTypes = (): string[] => [
  ...Object.keys(manualReviewTasks),
  ...Object.keys(notificationDefinitions)
]

export const getNotificationTaskTypes = (): string[] =>
  Object.keys(notificationDefinitions)

export const isRecognisedTaskType = (taskType: string): boolean =>
  taskType in manualReviewTasks || taskType in notificationDefinitions
